import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";
import usessionReducer from "./slices/usession-supabase";
import googleReducer from "./slices/google";
import pinterestReducer from "./slices/pinterest";
import systemReducer from "./slices/system";
import userDataReducer from "./slices/user-data";
import callsReducer from "./slices/calls";
import consentReducer from "./slices/consent";

// Combine your reducers
const rootReducer = combineReducers({
  usession: usessionReducer,
  call: callsReducer,
  google: googleReducer,
  pinterest: pinterestReducer,
  system: systemReducer,
  userData: userDataReducer,
  consent: consentReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "usession",
    "google",
    "pinterest",
    "system",
    "userData",
    "consent",
  ], // List the slices you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
